/* eslint-disable max-len */
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import useFontLoader from './FontHook';
export default function Preview({ state, handleClose }) {
    const customStore = useSelector(state => state.customization);
    const { custom } = customStore;
    const titleFont = useFontLoader(custom?.title_font_family?.files, custom?.title_font_family?.family);
    const bodyFont = useFontLoader(custom?.body_font_family?.files, custom?.body_font_family?.family);
    const CDNUrl = import.meta.env.VITE_CDN_URL
    const products = [
        {
            'name': 'Brilliant Diamond',
            'listing_price': '$3,500',
            'selling_price': '$3,200',
            'img': 'Rectangle0.png'
        },
        {
            'name': 'Brilliant Diamond',
            'listing_price': '$3,500',
            'selling_price': '$3,200',
            'img': 'Rectangle1.png'
        },
        {
            'name': 'Brilliant Diamond',
            'listing_price': '$3,500',
            'selling_price': '$3,200',
            
            'img': 'Rectangle2.png'
        },
        {
            'name': 'Brilliant Diamond',
            'listing_price': '$3,500',
            'selling_price': '$3,200',
            'img': 'Rectangle0.png'
        },
        {
            'name': 'Brilliant Cut Diamond Ring',
            'listing_price': '$3,500',
            'selling_price': '$3,200',
            'img': 'Rectangle1.png'
        },
        {
            'name': 'Brilliant Cut Diamond Ring',
            'listing_price': '$3,500',
            'selling_price': '$3,200',
            'img': 'Rectangle2.png'
        },
    ]
    useEffect(() => {
        const cleanup = [];
        if (titleFont) {
            const style1 = document.createElement('style');
            style1.appendChild(document.createTextNode(titleFont));
            document.head.appendChild(style1);
            cleanup.push(() => document.head.removeChild(style1));
        }
        if (bodyFont) {
            const style2 = document.createElement('style');
            style2.appendChild(document.createTextNode(bodyFont));
            document.head.appendChild(style2);
            cleanup.push(() => document.head.removeChild(style2));
        }
        return () => {
            cleanup.forEach(cleanupFn => cleanupFn());
        };
    }, [titleFont, bodyFont]);
    return (
    
        <div className='w-fit'>
            <div className='flex justify-between' >
                <p>Preview</p>
                <img src="/assets/images/close-24px.svg" data-testid="close-button" onClick={handleClose} className=' mr-[-4px]' alt="" />
            </div>
            <div className='mt-6 border border-[#BCBCBC] pr-2  xs:w-[260px] sm:w-[298px] overflow-hidden' style={{ backgroundColor: custom?.background_color || 'white' }}>
                <div className='mb-[40px]'>
                    <img src="/assets/images/status-bar.svg" alt="top-bar" />
                </div>
                <div className='overflow-x-hidden overflow-y-auto  h-productHeight scrollBar sideBar'>


                    <div className='relative flex justify-center pl-4 pr-2 tems-center '>
                        <img src="/assets/images/mqr-full-logo.svg" alt="logo" />
                        <img src="/assets/images/menu.svg" className='absolute top-2 left-5' alt="" />
                    </div>
                    <div className='pl-4 pr-2'>
                        <div className="flex justify-start border border-[#DDDDDD] w-full rounded-[6px] text-black mb-4 px-2 py-2" onClick={() => handleClick(item)} data-testid="store">
                            <div className='mr-3 border border-[#000000] rounded-[80px] overflow-hidden h-[75px] w-[75px] sm:h-[66px] sm:w-[80px] '>
                                <img src={state?.store_logo ? `${CDNUrl}${state?.store_logo}` : `/assets/images/store.svg`} className='h-[75px] w-[75px] object-contain pb-2'  alt='store' loading='Lazy' />
                            </div>
                            <div className='text-[#1F1F1F] py-2 w-[70%] sm:[w-80%] text-left pr-3'>
                                <h2 data-testid="store_name"
                                    className='font-semibold text-[12px]  w-[170px]  break-all s line-clamp-2'
                                    style={{ fontFamily: `${custom?.title_font_family?.family}, sans-serif`, color: custom?.title_text_color || '#1f1f1f' }}
                                >
                                    {state?.name?.toUpperCase() || '-'}
                                </h2>
                                <p className='break-all text-[#666666] text-[12px] font-normal  line-clamp-2 capitalize'
                                    style={{ fontFamily: `${custom?.body_font_family?.family}, sans-serif`, color: custom?.body_text_color || '#666666' }}
                                >
                                    
                                    {state?.address 
                                        ? state.address.toLowerCase().replace(/\b\w/g, char => char.toUpperCase()) 
                                        : '-'},  {state?.location 
                                        ? state.location.toLowerCase().replace(/\b\w/g, char => char.toUpperCase()) 
                                        : '-'}
                                </p>
                                <p className='break-all text-[#666666] text-[12px] font-normal line-clamp-1 capitalize'
                                    style={{ fontFamily: `${custom?.body_font_family?.family}, sans-serif`, color: custom?.body_text_color || '#666666' }}
                                >
                                    {state?.city 
                                        ? state.city.toLowerCase().replace(/\b\w/g, char => char.toUpperCase()) 
                                        : '-'},  {state?.postal_code || '-'}
                                </p>
                                {/* <p className='break-all text-[#666666] text-[12px] font-normal line-clamp-1'
                                    style={{ fontFamily: `${custom?.body_font_family?.family}, sans-serif`, color: custom?.body_text_color || '#666666' }}
                                >

                                    {state?.postal_code || '-'}
                                </p> */}
                                {/* <p className='break-all text-[#666666] text-[12px] font-normal line-clamp-2'
                                    style={{ fontFamily: `${custom?.body_font_family?.family}, sans-serif`, color: custom?.body_text_color || '#666666' }}
                                >
                                    {state?.url || '-'}
                                </p> */}
                                {/* <p className='break-all text-[#666666] text-[12px] font-normal  line-clamp-1'
                                    style={{ fontFamily: `${custom?.body_font_family?.family}, sans-serif`, color: custom?.body_text_color || '#666666' }}
                                >
                                    {state?.phone_number || '-'}
                                </p> */}
                            </div>
                        </div>
                    </div>
                    <div className='pl-4 pr-2'>
                        <div
                            className='py-[14px] border border-[#DDDDDD] px-4 flex justify-between items-center'

                        >
                            <p className='font-semibold text-xs text-[#1f1f1f]'
                                style={{ fontFamily: `${custom?.title_font_family?.family}, sans-serif`, color: custom?.title_text_color || '#1f1f1f' }}
                            >Parent category - Category name</p>
                            <div>
                                <img
                                    src="/assets/images/chevron-down.svg"
                                    alt="" />
                            </div>
                        </div>
                    </div>
                    {/* <div className='pl-4 pr-2 mt-3'>
                        <div className='px-3 py-2 rounded-[8px] border border-black flex justify-between items-center'>
                            <p className='text-xs text-[#1f1f1f]'
                                style={{ fontFamily: `${custom?.title_font_family?.family}, sans-serif`, color: custom?.title_text_color || '#1f1f1f' }}
                            ></p>
                            <img src="/assets/images/darksearch.svg" alt="" />
                        </div>
                    </div> */}
                    <div className='flex flex-wrap pl-4 pr-2 mt-3 -mx-2'>
                        {products.map((product, i) => (
                            <div key={i} className='w-1/3 px-2 mb-4'>
                                {/* Image inside a bordered box */}
                                <div className='overflow-hidden'>
                                    <img 
                                        src={`/assets/images/${product.img}`} 
                                        alt="product" 
                                        className='w-full h-[100px] md:h-[150px] object-cover'
                                    />
                                </div>

                                {/* Product Name & Pricing Below the Box */}
                                <p className='text-[9px] text-[#1f1f1f]  mt-2 uppercase truncate' title={product.name}
                                    style={{ fontFamily: `${custom?.title_font_family?.family}, sans-serif`, color: custom?.title_text_color || '#1f1f1f' }}
                                >
                                    {product.name}
                                </p>

                                <p className='text-[#DE2B2B] text-[9px] font-semibold '
                                    style={{ fontFamily: `${custom?.body_font_family?.family}, sans-serif`, color: custom?.primary_color || '#666666' }}
                                >
                                    <span className='line-through text-[#666666] text-[9px] font-semibold' 
                                        style={{ color: custom?.body_text_color }}>
                                        {product.listing_price}
                                    </span> 
                                    {product.selling_price}
                                </p>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </div>
    )
}
